import { Injectable } from '@angular/core';
import { RestfulService } from '../rest/restful';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';

@Injectable({
  providedIn: 'root'
})
export class FrontProfilesService extends RestfulService<Models.FrontProfileModel> {

  constructor(public restService: RestService) {
    super(Models.FrontProfileModel);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('front-profile-models');
  }
}
